import { AfterViewInit, Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { MonitoringImage } from '../../../cctv-monitoring/cctv-monitoring.models';
import { MapVehicle } from '../../cctv-monitoring-map.models';

type CameraCategory = 'cabin' | 'outside' | 'event';

@Component({
  selector: 'app-map-image-dialog',
  templateUrl: './map-image-dialog.component.html',
  styleUrls: ['../../../cctv-monitoring/components/image-dialog/image-dialog.component.css', './map-image-dialog.component.css'],
})
export class MapImageDialogComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() vehicle!: MapVehicle;
  @Input() images: MonitoringImage[] = [];
  @Input() category: CameraCategory = 'cabin';
  @Input() statusLabel = 'نامشخص';
  @Output() readonly close = new EventEmitter<void>();
  @Output() readonly zoomVehicle = new EventEmitter<void>();
  imageFailed = false;
  currentImage?: MonitoringImage;
  imageTime = 'زمان نامشخص';
  positionTime = 'نامشخص';
  private previousFocus: HTMLElement | null = null;

  ngOnInit(): void {
    this.previousFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
  }

  ngAfterViewInit(): void {
    document.getElementById('map-image-dialog-close')?.focus();
  }

  ngOnDestroy(): void {
    this.previousFocus?.focus();
  }

  ngOnChanges(): void {
    this.positionTime = [this.vehicle.strDate, this.vehicle.strTime].filter(Boolean).join(' ') || this.vehicle.strTimeAge || 'نامشخص';
    this.updateImage();
  }

  selectCategory(category: CameraCategory): void {
    this.category = category;
    this.imageFailed = false;
    this.updateImage();
  }

  private updateImage(): void {
    const image = this.images.find(item => item.unitId === this.vehicle.strUnitID && item.category === this.category);
    if (image !== this.currentImage) this.imageFailed = false;
    this.currentImage = image;
    const time = image ? Date.parse(image.date) : NaN;
    this.imageTime = Number.isFinite(time)
      ? new Date(time).toLocaleString('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })
      : 'زمان نامشخص';
  }

  @HostListener('document:keydown.escape')
  onEscape(): void { this.close.emit(); }

  @HostListener('document:keydown.tab', ['$event'])
  onTab(event: KeyboardEvent): void {
    const controls = Array.from(document.querySelectorAll<HTMLElement>('.map-image-dialog button:not([disabled]), .map-image-dialog a[href]'));
    if (!controls.length) return;
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
}
